<template>
  <div class="flex items-center">
    <div class="flex w-full bg-black shadow rounded" style="background-color: black; color: white;"> 
      <dropdown :auto-close="false" class="px-4 md:px-6 rounded-l border-r focus:border-white focus:ring focus:z-10" placement="bottom-start">
        <div class="flex items-baseline" >
          <span class="text-white hidden md:inline">Filtro</span>
        </div>
      </dropdown>
      <input class="text-white relative w-full px-6 py-3 rounded-r focus:ring" style="background-color: black; color: white;" autocomplete="off" type="text" name="search" placeholder="Buscar…" :value="value" @input="$emit('input', $event.target.value)" />
    </div>
    <button class="ml-3 text-sm text-gray-500 hover:text-gray-700 focus:text-indigo-500" type="button" @click="$emit('reset')">Resetear</button>
  </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
  },
  props: {
    value: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
}
</script>
